import { render } from "./LgpdView.vue?vue&type=template&id=378dc66f"
import script from "./LgpdView.vue?vue&type=script&lang=js"
export * from "./LgpdView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__